/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseRateIssueDTOFromJSON, PurchaseRateIssueDTOToJSON, } from './PurchaseRateIssueDTO';
import { PurchaseRateDTOFromJSON, PurchaseRateDTOToJSON, } from './PurchaseRateDTO';
/**
 * Check if a given object implements the PurchaseRatesResponse interface.
 */
export function instanceOfPurchaseRatesResponse(value) {
    return true;
}
export function PurchaseRatesResponseFromJSON(json) {
    return PurchaseRatesResponseFromJSONTyped(json, false);
}
export function PurchaseRatesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'slOrderId': json['slOrderId'] == null ? undefined : json['slOrderId'],
        'rates': json['rates'] == null ? undefined : (json['rates'].map(PurchaseRateDTOFromJSON)),
        'issues': json['issues'] == null ? undefined : (json['issues'].map(PurchaseRateIssueDTOFromJSON)),
        'replacedPreviousDraft': json['replacedPreviousDraft'] == null ? undefined : json['replacedPreviousDraft'],
        'currentRate': json['currentRate'] == null ? undefined : PurchaseRateDTOFromJSON(json['currentRate']),
        'currentSlOrderId': json['currentSlOrderId'] == null ? undefined : json['currentSlOrderId'],
        'buyerEmail': json['buyerEmail'] == null ? undefined : json['buyerEmail'],
    };
}
export function PurchaseRatesResponseToJSON(json) {
    return PurchaseRatesResponseToJSONTyped(json, false);
}
export function PurchaseRatesResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'slOrderId': value['slOrderId'],
        'rates': value['rates'] == null ? undefined : (value['rates'].map(PurchaseRateDTOToJSON)),
        'issues': value['issues'] == null ? undefined : (value['issues'].map(PurchaseRateIssueDTOToJSON)),
        'replacedPreviousDraft': value['replacedPreviousDraft'],
        'currentRate': PurchaseRateDTOToJSON(value['currentRate']),
        'currentSlOrderId': value['currentSlOrderId'],
        'buyerEmail': value['buyerEmail'],
    };
}
